
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fr/recherche",
      function () {
        return require("private-next-pages/fr/recherche.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fr/recherche"])
      });
    }
  